import type { ReactNode } from "react";
import { Redirect, useLocation } from "wouter";
import { useAuth } from "../auth/AuthContext";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  const [location] = useLocation();

  if (!session) {
    // `state` rides on the History API entry (see wouter's useHistoryState) so
    // LoginPage can send the operator back to what they actually asked for.
    return <Redirect to="/login" replace state={{ from: location }} />;
  }

  return children;
}
